import { VCF_AUTOFILL_SUPPORTED_PRODUCTS } from 'vrlcm-gui-constants';
import { safeJsonParse } from '../util-functions';
export var isVcfAdmin = function (user) {
    if (user) {
        return user.authorities.some(function (a) { return a === 'VCF_USER'; });
    }
    return false;
};
export var isVcfEnabledEnvironment = function (environment) {
    var properties = environment.infrastructure.properties;
    var vcfProperties = safeJsonParse(properties.vcfProperties);
    return !!(vcfProperties === null || vcfProperties === void 0 ? void 0 : vcfProperties.vcfEnabled);
};
export var isVcfEnabledEnvironmentWithVcfUser = function (environment, user) {
    if (!!user && isVcfAdmin(user)) {
        return isVcfEnabledEnvironment(environment);
    }
    return false;
};
export var isVcfPoweredProduct = function (environment, user) {
    if (isVcfEnabledEnvironmentWithVcfUser(environment, user)) {
        var products = environment.products;
        return products.every(function (p) {
            return VCF_AUTOFILL_SUPPORTED_PRODUCTS.some(function (pId) { return p.id === pId; });
        });
    }
    return false;
};
